import React from 'react';
import {
  SPOKE_ROLES,
  ROLE_REGIONAL_SUPERVISOR,
  PEDIATRIC_CENTRE_ROLES,
  ROLE_SUPPORT,
} from '../../../constants/roles';
import RouteDefinition from '../../../helpers/Route/RouteDefinition';
import { stringToBool } from '../../../helpers/Object';

export const viewNewbornRoute = new RouteDefinition({
  path: '/newborn/:newbornId/view',
  component: React.lazy(() => import('../View')),
  roles: [...SPOKE_ROLES, ROLE_REGIONAL_SUPERVISOR, ...PEDIATRIC_CENTRE_ROLES, ROLE_SUPPORT],
  register: false,
});

export const addNewbornRoute = new RouteDefinition({
  path: '/newborn/add',
  component: React.lazy(() => import('../Add')),
  roles: SPOKE_ROLES,
  register: false,
});

export const searchNewbornRoute = new RouteDefinition({
  path: '/newborn/search',
  component: React.lazy(() => import('../Search')),
  roles: SPOKE_ROLES,
  register: false,
  enabled: stringToBool(process.env.REACT_APP_ENABLE_CEDAP),
});

export const historyNewbornRoute = new RouteDefinition({
  path: '/newborn/:newbornId/history',
  component: React.lazy(() => import('../WorkgroupHistory')),
  roles: [...SPOKE_ROLES, ROLE_REGIONAL_SUPERVISOR],
  register: false,
});
